export function keysToArray (map) {
  const array = []
  for (const [key] of map) {
    array.push(key)
  }
  return array
}

export function valuesToArray (map) {
  const array = []
  for (const [, value] of map) {
    array.push(value)
  }
  return array
}

export function toArray (map) {
  const array = []
  for (const [key, value] of map) {
    array.push([key, value])
  }
  return array
}

export default {
  toArray,
  keysToArray,
  valuesToArray
}
